import React, { useState } from 'react';
import Header from './Header';
import Tabs from './Tabs';
import Announcements from './sections/Announcements';
import CurrentIssues from './sections/CurrentIssues';
import MostReadArticles from './sections/MostReadArticles';
import Journals from './sections/Journals';
import Books from './sections/Books';
import Events from './sections/Events';

function Dashboard() {
  const [activeTab, setActiveTab] = useState('announcements');

  const renderActiveSection = () => {
    switch (activeTab) {
      case 'announcements':
        return <Announcements />;
      case 'current-issues':
        return <CurrentIssues />;
      case 'most-read':
        return <MostReadArticles />;
      case 'journals':
        return <Journals />;
      case 'books':
        return <Books />;
      case 'events':
        return <Events />;
      default:
        return <Announcements />;
    }
  };

  return (
    <div className="dashboard">
      <Header />
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      {renderActiveSection()}
    </div>
  );
}

export default Dashboard;
